import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { OrganisationApi, SolrOrganisationReduced } from '../../../api/core';
import { SearchResult, SearchResultHeader } from './SearchResult';
import { BreakingList } from '../../detail/components/layout/BreakingList';
import { ExternalId } from '../../detail/components/ExternalId';
import { NavigateFunction, useNavigate } from 'react-router';
import { InternalLink } from '../../components/InternalLink';
import { deleteOrganisation, requestDeleteOrganisation } from '../../../util/actions/organisation-actions';
import { IntlShape, useIntl } from 'react-intl';
import { ToastContext, ToastContextType } from '../../../util/providers/ToastProvider';
import { getAuthMiddleware } from '../../../Auth/utils/GetAuthMiddleware';
import { AuthContext } from '../../../Auth/components/AuthProvider';
import { HierarchyBlock } from '../../components/HierarchyBlock';

export interface SearchResultOrganisationProps {
  key: number;
  position: number;
  result: SolrOrganisationReduced;
  redirectPath?: string;
}

export function SearchResultOrganisation(props: SearchResultOrganisationProps): ReactNode {
  const {actions} = useContext(AuthContext);
  const organisationApi: OrganisationApi = new OrganisationApi().withMiddleware(getAuthMiddleware(actions));
  const toast: ToastContextType = useContext(ToastContext);
  const intl: IntlShape = useIntl();
  const navigate: NavigateFunction = useNavigate();
  const {result} = props;

  const header: SearchResultHeader = {
    label: result.name.join(', '),
    url: `/organisation/${result.id}`,
  };

  const contents: ReactNode[] = [];
  if (result.gnd && result.gnd.length > 0) {
    contents.push(
      <BreakingList separator={'; '}>
        {result.gnd.map((externalId: string, idx: number) => (
          <div key={idx}><ExternalId id={{externalId, type: 'gnd'}} entity={'orga'}/></div>
        ))}
      </BreakingList>,
    );
  }
  if (result.hierarchy && result.hierarchy.length > 1) {
    result.hierarchy.reverse();
    result.hierarchy.pop();
    contents.push(<HierarchyBlock initial={true} breakpoint={'xl'}>
      {result.hierarchy.map((externalId: string, idx: number): ReactNode => {
        const splitted: string[] = externalId.split('#', 2);
        return <InternalLink key={idx} to={`/organisation/${splitted[0]}`}>{splitted[1]}</InternalLink>;
      })}
    </HierarchyBlock>)
    ;
  }

  return <SearchResult
    position={props.position}
    header={header}
    contents={contents}
    result={result}
    requestDelete={(): void => requestDeleteOrganisation(organisationApi, toast, intl, navigate, +result.id, result.name[0], props.redirectPath)}
    delete={(): void => deleteOrganisation(organisationApi, toast, intl, navigate, +result.id, result.name[0], props.redirectPath)}
    editUrl={`/organisation/${result.id}/edit`}
  />;
}
